import React from 'react';
import PropTypes from 'prop-types';

import './index.scss';

export default function Input({
  label,
  message,
  messageType,
  name,
  onBlur,
  onChange,
  onFocus,
  placeholder,
  type,
  value,
}) {
  return (
    <div className="Input">
      <label>
        {label ? <span className="Input__label">{label}</span> : null}

        <input
          className="Input__input"
          name={name}
          onBlur={onBlur}
          onFocus={onFocus}
          onChange={onChange}
          placeholder={placeholder}
          type={type}
          value={value}
        />
      </label>
      {message ? <span className={`Input__info--${messageType}`}>{message}</span> : null}
    </div>
  );
}

Input.propTypes = {
  label: PropTypes.string,
  message: PropTypes.string,
  messageType: PropTypes.oneOf(['error', 'success', 'regular']),
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  placeholder: PropTypes.string,
  type: PropTypes.oneOf(['text', 'number']),
  value: PropTypes.string,
};

Input.defaultProps = {
  placeholder: '',
  message: null,
  label: null,
  messageType: 'regular',
  name: '',
  type: 'text',
  value: '',
  onChange: () => {},
  onBlur: () => {},
  onFocus: () => {},
};
